import Notifications from 'views/molecules/notification/Notifications';

export default Notifications;
